import { Role } from '__types__';

const Roles: Role[] = [
  {
    id: 'admin',
    name: 'Admin',
    description:
      'Full access and editability across spaces and administration configuration'
  },
  {
    id: 'regular',
    name: 'Regular',
    description:
      'Can create and edit anything. Limited access to workspace settings.'
  }
  // Unused for now
  // { id: 3, name: 'Collaborator', description: 'TODO' }
];

export default Roles;
